import { render, staticRenderFns } from "./RobberyLostKeysCircumstancesQuestion.vue?vue&type=template&id=57470478&scoped=true"
import script from "./RobberyLostKeysCircumstancesQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyLostKeysCircumstancesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyLostKeysCircumstancesQuestion.vue?vue&type=style&index=0&id=57470478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57470478",
  null
  
)

export default component.exports